import React, { useState, useEffect } from 'react';

const PerfilAgricultorPage = ({ onNavigate, nomeUsuario }) => {
  const [perfil, setPerfil] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [editando, setEditando] = useState(false);
  
  const [dadosEdicao, setDadosEdicao] = useState({
    nome: '',
    email: '',
    cnpj: '',
    telefone: '',
    cep: '',
    logradouro: '',
    numero: '',
    complemento: '',
    cidade: '',
    estado: ''
  });

  const agricultorId = localStorage.getItem('agricultorId');

  useEffect(() => {
    carregarPerfil();
  }, []);

  const carregarPerfil = async () => {
    if (!agricultorId) {
      setError('ID do agricultor não encontrado');
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(`http://localhost:3000/agricultores/${agricultorId}`);
      
      if (response.ok) {
        const data = await response.json();
        setPerfil(data);
        setDadosEdicao({
          nome: data.nome || '',
          email: data.email || '',
          cnpj: data.cnpj || '',
          telefone: data.telefone || '',
          cep: data.cep || '',
          logradouro: data.logradouro || '',
          numero: data.numero || '',
          complemento: data.complemento || '',
          cidade: data.cidade || '',
          estado: data.estado || ''
        });
        setError('');
      } else {
        console.error('Erro ao carregar perfil');
        setError('Erro ao carregar perfil');
      }
    } catch (error) {
      console.error('Erro ao carregar perfil:', error);
      setError('Erro de conexão com o servidor');
    } finally {
      setLoading(false);
    }
  };

  const handleSalvarEdicao = async (event) => {
    event.preventDefault();
    setError('');
    setSuccess('');

    try {
      const response = await fetch(`http://localhost:3000/agricultores/${agricultorId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dadosEdicao),
      });

      if (response.ok) {
        setSuccess('Dados atualizados com sucesso!');
        setEditando(false);
        carregarPerfil();
        setTimeout(() => setSuccess(''), 3000);
      } else {
        const errorData = await response.json();
        setError(errorData.error || 'Erro ao atualizar dados');
      }
    } catch (error) {
      console.error('Erro ao atualizar dados:', error);
      setError('Erro de conexão com o servidor');
    }
  };

  const handleCancelarEdicao = () => {
    setEditando(false);
    setDadosEdicao({
      nome: perfil.nome || '',
      email: perfil.email || '',
      cnpj: perfil.cnpj || '',
      telefone: perfil.telefone || '',
      cep: perfil.cep || '',
      logradouro: perfil.logradouro || '',
      numero: perfil.numero || '',
      complemento: perfil.complemento || '',
      cidade: perfil.cidade || '',
      estado: perfil.estado || ''
    });
    setError('');
  };

  if (loading) {
    return (
      <div className="profile-container">
        <div className="loading-state">
          <div className="loading-spinner"></div>
          <p>Carregando perfil...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="profile-container">
      <div className="profile-content">
        {error && (
          <div className="alert alert-error">
            <span className="alert-icon">⚠️</span>
            <span className="alert-text">{error}</span>
          </div>
        )}
        {success && (
          <div className="alert alert-success">
            <span className="alert-icon">✓</span>
            <span className="alert-text">{success}</span>
          </div>
        )}

        {perfil && !editando && (
          <div className="data-view-section">
            <div className="section-header">
              <h2 className="section-title">
                <span className="title-icon">👤</span>
                Meus Dados
              </h2>
              <button 
                className="btn-edit"
                onClick={() => setEditando(true)}
              >
                <span className="btn-icon">✏️</span>
                Editar
              </button>
            </div>

            <div className="data-cards-grid">
              <div className="data-card">
                <h3 className="data-card-title">Informações do Negócio</h3>
                <div className="data-card-content">
                  <div className="data-item">
                    <span className="data-label">Nome</span>
                    <span className="data-value">{perfil.nome}</span>
                  </div>
                  <div className="data-item">
                    <span className="data-label">Email</span>
                    <span className="data-value">{perfil.email}</span>
                  </div>
                  <div className="data-item">
                    <span className="data-label">CNPJ</span>
                    <span className="data-value">{perfil.cnpj}</span>
                  </div>
                  <div className="data-item">
                    <span className="data-label">Telefone</span>
                    <span className="data-value">{perfil.telefone || 'Não informado'}</span>
                  </div>
                </div>
              </div>

              <div className="data-card">
                <h3 className="data-card-title">Endereço</h3>
                <div className="data-card-content">
                  <div className="data-item">
                    <span className="data-label">CEP</span>
                    <span className="data-value">{perfil.cep || 'Não informado'}</span>
                  </div>
                  <div className="data-item">
                    <span className="data-label">Logradouro</span>
                    <span className="data-value">{perfil.logradouro || 'Não informado'}</span>
                  </div>
                  <div className="data-item">
                    <span className="data-label">Número</span>
                    <span className="data-value">{perfil.numero || 'Não informado'}</span>
                  </div>
                  <div className="data-item">
                    <span className="data-label">Complemento</span>
                    <span className="data-value">{perfil.complemento || 'Não informado'}</span>
                  </div>
                  <div className="data-item">
                    <span className="data-label">Cidade</span>
                    <span className="data-value">{perfil.cidade || 'Não informado'}</span>
                  </div>
                  <div className="data-item">
                    <span className="data-label">Estado</span>
                    <span className="data-value">{perfil.estado || 'Não informado'}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {editando && (
          <div className="edit-view-section">
            <div className="section-header">
              <h2 className="section-title">
                <span className="title-icon">✏️</span>
                Editar Dados
              </h2>
            </div>

            <form onSubmit={handleSalvarEdicao} className="edit-form">
              <div className="form-section">
                <h3 className="form-section-title">Informações do Negócio</h3>
                <div className="form-grid">
                  <div className="form-group">
                    <label htmlFor="nome">Nome *</label>
                    <input
                      type="text"
                      id="nome"
                      value={dadosEdicao.nome}
                      onChange={(e) => setDadosEdicao({ ...dadosEdicao, nome: e.target.value })}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="email">Email *</label>
                    <input
                      type="email"
                      id="email"
                      value={dadosEdicao.email}
                      onChange={(e) => setDadosEdicao({ ...dadosEdicao, email: e.target.value })}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="cnpj">CNPJ *</label>
                    <input
                      type="text"
                      id="cnpj"
                      value={dadosEdicao.cnpj}
                      onChange={(e) => setDadosEdicao({ ...dadosEdicao, cnpj: e.target.value })}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="telefone">Telefone</label>
                    <input
                      type="text"
                      id="telefone"
                      value={dadosEdicao.telefone}
                      onChange={(e) => setDadosEdicao({ ...dadosEdicao, telefone: e.target.value })}
                      placeholder="(00) 00000-0000"
                    />
                  </div>
                </div>
              </div>

              <div className="form-section">
                <h3 className="form-section-title">Endereço</h3>
                <div className="form-grid">
                  <div className="form-group">
                    <label htmlFor="cep">CEP</label>
                    <input
                      type="text"
                      id="cep"
                      value={dadosEdicao.cep}
                      onChange={(e) => setDadosEdicao({ ...dadosEdicao, cep: e.target.value })}
                      placeholder="00000-000"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="logradouro">Logradouro</label>
                    <input
                      type="text"
                      id="logradouro"
                      value={dadosEdicao.logradouro}
                      onChange={(e) => setDadosEdicao({ ...dadosEdicao, logradouro: e.target.value })}
                      placeholder="Rua, Avenida, etc."
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="numero">Número</label>
                    <input
                      type="text"
                      id="numero"
                      value={dadosEdicao.numero}
                      onChange={(e) => setDadosEdicao({ ...dadosEdicao, numero: e.target.value })}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="complemento">Complemento</label>
                    <input
                      type="text"
                      id="complemento"
                      value={dadosEdicao.complemento}
                      onChange={(e) => setDadosEdicao({ ...dadosEdicao, complemento: e.target.value })}
                      placeholder="Apto, Sala, etc."
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="cidade">Cidade</label>
                    <input
                      type="text"
                      id="cidade"
                      value={dadosEdicao.cidade}
                      onChange={(e) => setDadosEdicao({ ...dadosEdicao, cidade: e.target.value })}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="estado">Estado</label>
                    <input
                      type="text"
                      id="estado"
                      value={dadosEdicao.estado}
                      onChange={(e) => setDadosEdicao({ ...dadosEdicao, estado: e.target.value })}
                      placeholder="SP"
                      maxLength="2"
                    />
                  </div>
                </div>
              </div>

              <div className="form-actions">
                <button type="submit" className="btn-save">
                  <span className="btn-icon">✓</span>
                  Salvar Alterações
                </button>
                <button type="button" className="btn-cancel" onClick={handleCancelarEdicao}>
                  <span className="btn-icon">✕</span>
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};

export default PerfilAgricultorPage;
